import type { HubBannerDto } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core";
import { useQuery } from "@tanstack/react-query";

export const useHubBanners = () => {
  const api = useApi();

  const { data, isLoading } = useQuery<HubBannerDto[]>({
    queryKey: [QueryKeys.HUB_BANNERS],
    queryFn: async () => {
      return api.getOrThrow(API_ENDPOINT.HUB_BANNERS_ACTIVE);
    },
    staleTime: 60_000, // 1 minute
    refetchInterval: 5 * 60_000, // Refetch every 5 minutes
  });

  return {
    banners: data ?? [],
    isLoading,
  };
};
